export const alert24SolidIcon = {
    data: `<svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24"><path fill="currentColor" d="M23.25 23.23a.75.75 0 0 0 .66-1.1l-11.25-21a.78.78 0 0 0-1.32 0l-11.25 21a.73.73 0 0 0 .64 1.1zM12 20.48a1.5 1.5 0 1 1 0-2.999 1.5 1.5 0 0 1 0 2.999m0-12.25a1 1 0 0 1 1 1v5.47a1 1 0 0 1-2 0V9.23a1 1 0 0 1 1-1"/></svg>`,
    name: 'alert-24-solid'
};